import { useDiscover } from '../hooks/useDiscover'
import FlexibleMatchingSection from './FlexibleMatchingSection'

export default function ConditionalFlexibleMatchingSection({
  className,
  career = null,
  talent = null,
  careers = [],
  talents = []
}) {
  const { isFlexibleMatchingEnabled } = useDiscover()

  if (!isFlexibleMatchingEnabled) return null

  return (
    <FlexibleMatchingSection
      className={className}
      career={career}
      talent={talent}
      selectedCareers={careers}
      selectedTalents={talents}
    />
  )
}
